/* Crisp inline SVGs for the widget. currentColor-driven so they inherit
   the brand/header colors. Kept tiny — no icon-font dependency. */

import { STRATUS_LOGO } from './logo';

/** The Stratus wing mark — the assistant avatar. Inlined data URI, so it
    renders in the shadow-DOM widget on any site with no external request. */
export function LogoMark() {
  return <img class="logo-img" src={STRATUS_LOGO} alt="" aria-hidden="true" />;
}

/** Rounded chat bubble — the launcher. */
export function ChatIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8A2.5 2.5 0 0 1 17.5 16H10l-4.2 3.4A.75.75 0 0 1 4.6 18.8l.2-2.8H6.5A2.5 2.5 0 0 1 4 13.5v-8Z"
        fill="currentColor"
      />
      <circle cx="9" cy="9.5" r="1.15" fill="#fff" />
      <circle cx="12.5" cy="9.5" r="1.15" fill="#fff" />
      <circle cx="16" cy="9.5" r="1.15" fill="#fff" />
    </svg>
  );
}

/** Upward arrow — send. */
export function SendIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 19V6m0 0-5 5m5-5 5 5"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="m6 6 12 12M18 6 6 18"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
      />
    </svg>
  );
}

/** Shield-check — the privacy/disclaimer notice. */
export function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 3l7 2.5v5.2c0 4.4-3 7.6-7 9.3-4-1.7-7-4.9-7-9.3V5.5L12 3Z"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linejoin="round"
      />
      <path
        d="m9.2 11.8 1.9 1.9 3.7-3.9"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

/** Thumbs up — feedback control on a bot turn. */
export function ThumbUpIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M7 10.5v9H4.5a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1H7Zm2 0 3.6-6.9a.9.9 0 0 1 1.2-.4l.5.25a2 2 0 0 1 1 2.3L14.6 9h4.1a1.8 1.8 0 0 1 1.75 2.24l-1.6 6.3A2.2 2.2 0 0 1 16.7 19.5H9v-9Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Thumbs down — feedback control on a bot turn. */
export function ThumbDownIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M7 13.5v-9H4.5a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1H7Zm2 0 3.6 6.9a.9.9 0 0 0 1.2.4l.5-.25a2 2 0 0 0 1-2.3L14.6 15h4.1a1.8 1.8 0 0 0 1.75-2.24l-1.6-6.3A2.2 2.2 0 0 0 16.7 4.5H9v9Z"
        fill="currentColor"
      />
    </svg>
  );
}
